import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router';

import { PolicyFileIngestionTable } from './policy/policy-file-ingestions/table';
import { CheckFileIngestionTable } from './specialty-check/check-file-ingestions/table';

export function Geovera() {
	const nav = useNavigate();
	const tab = window.location.pathname.split('/').pop();
	return (
		<Tabs defaultValue={tab} onValueChange={(value) => nav(`/geovera/${value}`)}>
			<TabsList className="grid w-full grid-cols-2">
				<TabsTrigger value="policies">Policy Feed</TabsTrigger>
				<TabsTrigger value="checks">Check Feed</TabsTrigger>
			</TabsList>
			<TabsContent value="policies">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle>Policy Feed</CardTitle>
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<PolicyFileIngestionTable />
					</CardContent>
				</Card>
			</TabsContent>
			<TabsContent value="checks">
				<Card>
					<CardHeader>
						<span className="flex flex-row justify-between">
							<CardTitle className="mt-2">Check Feed</CardTitle>
						</span>
					</CardHeader>
					<CardContent className="space-y-2">
						<CheckFileIngestionTable />
					</CardContent>
				</Card>
			</TabsContent>
		</Tabs>
	);
}
